import { createClient } from "contentful";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { img1_home, img2_home, main_banner } from "../../assets";
import Button from "../../shared/buttons";
import Heading from "../../shared/headings";
import LinkRouter from "../../shared/navegateButtons";
import Paragraph from "../../shared/paragraphs";
import { ACCESS_TOKEN, SPACE } from "./constants/contentful";
import Posts from "./posts";
import { Banner, Container, ContainerTextWithImage } from "./styles";

function Home() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [client] = useState(
    createClient({ space: SPACE, accessToken: ACCESS_TOKEN })
  );

  async function getAllEntries() {
    try {
      const res = await client.getEntries();
      setPosts(res.items);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getAllEntries();
  }, []);

  return (
    <Container>
      <Banner>
        <img src={main_banner} alt="Main Banner Home" />
        <div>
          <div>
            <Heading
              text={"DIVERSÃO E INCLUSÃO"}
              color={"primary"}
              size={"h3"}
            ></Heading>
            <Paragraph
              text={
                "Sempre acreditamos no papel da inclusão e no papel educativo do brincar."
              }
              type={"P2"}
              color={"primary"}
            />
          </div>
          <Button
            text={"Como Ajudar ?"}
            typeButton={"primary"}
            size={"small"}
            func={() => navigate("/help")}
          />
        </div>
      </Banner>

      <ContainerTextWithImage>
        <div>
          <Paragraph
            text={
              "Em 2021, passamos a ser uma agência de transfomação social com apoio da Gerando Falcões para as pessoas com e sem deficiência, buscando aumentar as oportunidades através do polo de esporte, cultura e qualificação profissional para as pessoas com e sem deficiência."
            }
            color={"black"}
            type={"P2"}
          />
          <img src={img1_home} alt="" />
        </div>

        <div>
          <img src={img2_home} alt="" />
          <Paragraph
            text={
              "O Circuito Inclusão é um projeto sem fins lucrativos e conta com o apoio de diversos parceiros da iniciativa pública e privada, assim como, diversos voluntários para promover lazer e atividades recreativas inclusivas para pessoas com deficiência."
            }
            color={"black"}
            type={"P2"}
          />
        </div>
        <LinkRouter caminho="/about" titulo="CONHEÇA NOSSA HISTÓRIA" />
      </ContainerTextWithImage>
      {posts ? <Posts posts={posts} /> : null}
    </Container>
  );
}

export default Home;
